import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
   apiKey: "AIzaSyDfEDfmdl6SWPlobMRa600TvlVLuHtP3cE",
  authDomain: "gaayanmart.firebaseapp.com",
  projectId: "gaayanmart",
  storageBucket: "gaayanmart.firebasestorage.app",
  messagingSenderId: "527173009822",
  appId: "1:527173009822:web:484539e516b017ea24d68f",
  measurementId: "G-M86QD06G0S"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { messaging };